const SECURITY_QUESTIONS = [
  "What was the name of your first pet?",
  "What is the name of the town where you were born?",
  "What was the name of your first school?",
  "What is your oldest sibling's middle name?",
  "What was the make of your first car?",
  "What is the name of your favorite childhood teacher?",
  "What was the first concert you attended?",
  "What is the name of the street where you grew up?",
  "What was your childhood nickname?",
  "What is the name of your favorite childhood book?",
];

export default SECURITY_QUESTIONS;